import React from 'react';
import {
    TextField,
    FormControlLabel,
    Checkbox,
    Tooltip,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import InputTitle from '../InputTitle';
import AutoComplete from '@mui/material/Autocomplete';
import InfoIcon from '@mui/icons-material/Info';
import './ActualHours.scss';

/**
 * @typedef {{
 *  isActualHours: boolean,
 *  setIsActualHours: () => void,
 *  isSelectBreakRuleId?: boolean,
 *  breakRuleId?: number | null,
 *  setBreakRuleId?: () => void | null,
 *  breakRules?: RuleSet.IRuleSetBrief[] | null,
 *  helpIconTooltip?: string,
 *  isDisabled?: boolean,
 * }} ActualHoursProps
 * @param {ActualHoursProps} props 
 */
export default function ActualHours(props) {
    const { isActualHours, setIsActualHours, isSelectBreakRuleId = true, breakRuleId, setBreakRuleId = () => {}, breakRules = [], helpIconTooltip = "", isDisabled = false } = props;
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'settings.ruleSet.scheduleRulesStep.actualHours' });
    const breakRuleOptions = [{id: null, name: t('defaultBreakRuleLabel')}, ...breakRules.map(x => ({ id: x.ruleSetId, name: x.name }))];

    /**
     * @param {boolean} isChecked 
     */
    const onChangeIsActualHours = (isChecked) => {
        // Reset sub-section value
        setBreakRuleId(null);
        setIsActualHours(isChecked);
    }

    return (
        <div>
            <FormControlLabel
                control={(
                    <Checkbox
                        checked={isActualHours}
                        onClick={({ target: { checked: isChecked } }) => onChangeIsActualHours(isChecked)}
                    />
                )}
                label={t('label')}
                disabled={isDisabled}
            />
            <Tooltip title={helpIconTooltip} arrow>
                <InfoIcon style={{ width: '15px', height: '15px', fontSize: '15px' }} />
            </Tooltip>
            {isSelectBreakRuleId && isActualHours && <div className='ac-break-rule-id-container'>
                <InputTitle>
                    {t('breakRuleLabel')}
                    <Tooltip title={t('breakRuleTooltip')} arrow>
                        <InfoIcon style={{ width: '15px', height: '15px', fontSize: '15px', marginLeft: '8px', cursor: 'pointer', color: 'rgba(0, 0, 0, 0.87)' }} />
                    </Tooltip>
                </InputTitle>
                <AutoComplete
                    id="break-rule-select"
                    value={breakRuleOptions.find((x) => x.id === breakRuleId)}
                    options={breakRuleOptions}
                    onChange={(_event, optionSelected) => setBreakRuleId(optionSelected?.id)}
                    renderInput={(params) => (<TextField
                        {...params}
                        variant="outlined"
                        placeholder={t('breakRulePlaceholder')}
                    />)}
                    getOptionLabel={(option) => option.name}
                    includeInputInList
                    disableClearable
                    disabled={isDisabled}
                />
            </div>}
        </div>
    );
}